/* eslint-disable */
import * as filterActions from '../../../Store/Filters/Filters.types';
import { createActionTypeEvents } from '../Analytics.utils';

const actionTypeEvents = createActionTypeEvents(Object.values(filterActions));

/**
 * The filter status selected event
 * @param {func} metaDataFunc The meta data func
 * @returns {any} The analytics data
 */
const filterStatusSelectedEvent = (metaDataFunc) => ({
  ...actionTypeEvents(metaDataFunc),
  [filterActions.FILTER_STATUS_SELECTED]: ({ payload, type }) => {
    // Instead of just sending all selected status filters,
    // extract the diff
    return {
      ...metaDataFunc(),
      data: { orderStatus: payload },
      event: type,
    };
  },
});

export default filterStatusSelectedEvent;
